import Icon from './Icon'

interface DisclaimerProps {
  onClose: () => void
}

function Disclaimer({ onClose }: DisclaimerProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[color:var(--color-bg-deep)]/80 backdrop-blur-sm">
      <div className="pixel-box pixel-box-bright p-4 max-w-lg w-full">
        <div className="flex items-center gap-2 mb-3">
          <span className="text-[color:var(--color-warning)] pixel-blink inline-flex">
            <Icon name="warn" size={18} />
          </span>
          <h2 className="font-pixel text-[10px] text-[color:var(--color-warning)] tracking-wider">
            免责声明
          </h2>
        </div>

        <div className="space-y-2 mb-4 font-pixel-body text-sm text-[color:var(--color-text)]">
          <p>
            ► 本产品仅用于交易知识学习与决策训练，<span className="text-[color:var(--color-bear)]">不构成投资建议</span>、证券推荐或收益承诺。
          </p>
          <p>
            ► 游戏中的行情、标的、数据和结果可能经过<span className="text-[color:var(--color-warning)]">合成、改编或脱敏处理</span>，不能直接用于现实交易。
          </p>
          <p>
            ► 继续使用即表示您理解并同意以上说明。
          </p>
        </div>

        <button onClick={onClose} className="pixel-button pixel-button-primary w-full">
          ► 我同意，开始训练
        </button>
      </div>
    </div>
  )
}

export default Disclaimer